(function () {
  'use strict';
  if (window.kinsoraRelatedProductsMounted) return;
  window.kinsoraRelatedProductsMounted = true;

  function mount(scope) {
    scope.querySelectorAll('[data-ks-related]').forEach(function (section) {
      if (section.dataset.relatedMounted) return;
      section.dataset.relatedMounted = 'true';
      var grid = section.querySelector('.products-grid');
      if (!grid) return;
      if (!grid.children.length) section.hidden = true;
      function load() {
        var url = new URL(section.dataset.url, window.location.origin);
        var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        fetch(url.toString(), { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Recommendations unavailable');
            return response.text();
          })
          .then(function (html) {
            if (!section.isConnected) return;
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var replacement = parsed.querySelector('[data-ks-related] .products-grid');
            if (replacement && replacement.children.length) {
              grid.replaceChildren.apply(grid, Array.from(replacement.children));
              section.hidden = false;
            }
          })
          .catch(function () { /* Keep the server-rendered category fallback. */ });
      }
      if (!window.IntersectionObserver || section.hidden) { load(); return; }
      var observer = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        observer.disconnect();
        load();
      }, { rootMargin: '400px' });
      observer.observe(section);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); });
  else mount(document);
  document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
}());
